import { FC, forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { useTenantCheckInfo } from '@/common/hook/useTenantCheckInfo';
import TaskDetailDrawer from '@/common/components/business/ExpandStore/TaskDetailDrawer';
import CircleTaskDetailDrawer from '@/views/expandstore/pages/expansioncircletask/components/Detail';
import SemirTaskDetailDrawer from '@/views/expandstore/pages/expansioncirclesenmatask/components/Detail';
import ExpansionFranchiseeCircleTaskDrawer from '@/views/expandstore/pages/expansionFranchiseeCircleTask/pages/detail/Drawer';
import SjtbTaskDetailDrawer from '@/views/expandstore/pages/expansionsjtbtask/components/TaskDetailDrawer';

/**
 * @Description 自动适配各种拓店任务模板下的详情
 *
 * 用法
 *
 * import AdaptiveTaskDetail from '@/common/components/business/ExpandStore/AdaptiveTaskDetail';
 *
 * const detailRef: any = useRef(null);
 *
 *    <AdaptiveTaskDetail
        ref={detailRef}
        hideOperate={true}
        reload={() => methods.refreshCurrentPage()}
      />

    handleTaskDetail(record: any) {
      (detailRef.current as any).handleTaskDetail(record.id);
    }
 *
 */
const AdaptiveTaskDetail: FC<{
  isHistory?: boolean;
  hideOperate?: boolean;
  hideClusterDetail?: boolean;
  reload?: Function;
  ref: any;
}> = forwardRef(({
  isHistory = false,
  hideOperate = false,
  hideClusterDetail = false,
  reload
}, ref) => {

  useImperativeHandle(ref, () => ({
    handleTaskDetail
  }));

  const { taskTemplateCode } = useTenantCheckInfo();

  const detailRef: any = useRef();
  const [taskVisible, setTaskVisible] = useState<boolean>(false); // 拓店任务
  const [curTaskId, setCurTaskId] = useState<number>(0);

  const handleTaskDetail = (taskId: number) => {
    console.log(111, taskTemplateCode, taskId);
    if (!taskTemplateCode || !taskId) return;
    if (['standardAndClusterA', 'standardAndClusterB'].includes(taskTemplateCode)) { // 如果是加盟+直营A（基诺浦）、加盟+直营B（一鸣）
      detailRef.current?.init(taskId);
      console.log(222);
    } else if (taskTemplateCode) {
      console.log(333);
      setCurTaskId(taskId);
      setTaskVisible(true); // 显示弹窗
    }
  };

  return (
    <>
      {/* 拓店任务 */}
      {taskTemplateCode === 'standardA' && <TaskDetailDrawer
        id={curTaskId}
        open={taskVisible}
        setOpen={setTaskVisible}
        isHistory={isHistory}
        hideOperate={hideOperate}
        outterRefresh={reload}
      />}
      {/* 三津汤包模板 */}
      {taskTemplateCode === 'standardC' && <SjtbTaskDetailDrawer
        id={curTaskId}
        open={taskVisible}
        setOpen={setTaskVisible}
        hideOperate={hideOperate}
        outterRefresh={reload}
      />}
      {/* 直营模板 */}
      {['clusterA', 'clusterB'].includes(taskTemplateCode) && <CircleTaskDetailDrawer
        id={curTaskId}
        open={taskVisible}
        setOpen={setTaskVisible}
        isHistory={isHistory}
        hideOperate={hideOperate}
        hideClusterDetail={hideClusterDetail}
        outterRefresh={reload}
      />}
      {/* 森马模板 */}
      {taskTemplateCode === 'clusterC' && <SemirTaskDetailDrawer
        id={curTaskId}
        open={taskVisible}
        setOpen={setTaskVisible}
        isHistory={isHistory}
        hideOperate={hideOperate}
        hideClusterDetail={hideClusterDetail}
        outterRefresh={reload}
      />}
      {/* 加盟+直营A（基诺浦）、加盟+直营B（一鸣） */}
      {['standardAndClusterA', 'standardAndClusterB'].includes(taskTemplateCode) && <ExpansionFranchiseeCircleTaskDrawer
        ref={detailRef}
        isHistory={isHistory}
        hideOperate={hideOperate}
        hideClusterDetail={hideClusterDetail}
        reload={reload}
      />}
    </>
  );
});

export default AdaptiveTaskDetail;
